"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('moon', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: props.strokeLinejoin
  }, _react.default.createElement("g", {
    transform: "translate(4.000000, 4.000000)",
    fill: props.outFillColor,
    fillRule: "nonzero",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("path", {
    d: "M24.0527397,0.41085238 C18.5827579,1.83694648 14.5454545,6.81062824 14.5454545,12.7272727 C14.5454545,19.7563514 20.2436486,25.4545455 27.2727273,25.4545455 C33.1893718,25.4545455 38.1630535,21.4172421 39.5891476,15.9472603 C39.8585051,17.2560374 40,18.6114947 40,20 C40,31.045695 31.045695,40 20,40 C8.954305,40 0,31.045695 0,20 C0,8.954305 8.954305,0 20,0 C21.3885053,0 22.7439626,0.141494924 24.0527397,0.41085238 Z"
  }))));
});

exports.default = _default;